module.exports = __webpack_public_path__ + "static/scale-model-of-round-rock-texas-12e9962c49e971d898f93b27361c4a70.png";